import { render } from "./CollectionAd.vue?vue&type=template&id=42efd233"
import script from "./CollectionAd.vue?vue&type=script&lang=js"
export * from "./CollectionAd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__